// extracted by mini-css-extract-plugin
export default {"wrapper":"noteFormContainer_wrapper__xz411","actionJSON":"noteFormContainer_actionJSON__31-Mg"};